import React from 'react'

function Loading() {
    return (
        <div className="preloader">
            <div className="box"></div>
            <div className="box"></div>
            <div className="box"></div>
            <div className="box"></div>
            <div className="box"></div>
            <div className="box"></div>
        </div>
    )
}

export default Loading
